export class LandingVideosSettingsEntity {
  homeYoutubeUrl: string | null

  barsYoutubeUrl: string | null

  restaurantsYoutubeUrl: string | null

  publicMenuYoutubeUrl: string | null

  ownerOnboardingDesktopYoutubeUrl: string | null

  ownerOnboardingMobileYoutubeUrl: string | null

  constructor(value: Partial<LandingVideosSettingsEntity> = {}) {
    this.homeYoutubeUrl = value?.homeYoutubeUrl?.trim() || null

    this.barsYoutubeUrl = value?.barsYoutubeUrl?.trim() || null

    this.restaurantsYoutubeUrl = value?.restaurantsYoutubeUrl?.trim() || null

    this.publicMenuYoutubeUrl = value?.publicMenuYoutubeUrl?.trim() || null

    this.ownerOnboardingDesktopYoutubeUrl = value?.ownerOnboardingDesktopYoutubeUrl?.trim() || null

    this.ownerOnboardingMobileYoutubeUrl = value?.ownerOnboardingMobileYoutubeUrl?.trim() || null
  }
}
